// extracted by mini-css-extract-plugin
module.exports = {"paper":"src-com-components-paper-index__paper","paper-title":"src-com-components-paper-index__paper-title","paper-info":"src-com-components-paper-index__paper-info"};